// extracted by mini-css-extract-plugin
export var accountHeader = "account-layout-module--account-header--ndgIC";
export var accountLayout = "account-layout-module--account-layout--GdR3I";
export var accountLayoutContainer = "account-layout-module--account-layout-container--yElxA";
export var content = "account-layout-module--content--XG40w";
export var menuShown = "account-layout-module--menu-shown--Fx3df";
export var sidebar = "account-layout-module--sidebar--MDYAr";
export var sidebarOpened = "account-layout-module--sidebar--opened--1O1BL";